import { theme } from "../../theme";

export const UniversalListStyle = {
  wrapper: {
    position: "relative",
    textAlign: "center",
    // marginTop: "60px",
    height: "100%",
    width: "100%",
    "&.CheckedInAttendees": {
      "& .MuiFormControlLabel-root": {
        mr: 0,
      }
    }
  },
  listWrapper: {
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    borderRadius: "5px",
    height: "100%",
    // height: 'calc(100vh - 165px)',
  },
  listRoot: {
    p:0,
    "& .MuiListItem-root": {
      cursor: "pointer",
      
      "& .MuiCheckbox-root": { color: `${theme.palette.grey[800]}` },
      "&:hover, &.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        "& .attendeeAvatar": {
          backgroundColor: "#fff",
          color: theme.palette.primary.main,
        },
        "& .attendeeDetails": {
          color: "#fff",
          '& .MuiTypography-root': {
            color: "#fff",
          }
        },
        "& p, && .actionIcon, && .attendeeName, && .attendeeCompany, && .viewIcon, & .MuiButton-text": {
          color: "#fff",
        },
        '& .MuiCheckbox-root': {
          color: "#fff !important",
        },
        "& .avatarIcon": {
          display: "none",
        },
      },
    },
  },
  actionButton: {
    borderRadius: "12px",
    height: "25px",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    marginRight: "20px",
  },
  bulkActionButton: {
    marginRight: "20px",
  },
  customActionButton: {
    marginLeft: "20px",
    color: "primary.main",
  },
  loading: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  bulkActions: {
    height: "55px",
    backgroundColor: theme.palette.grey[500],
    color: "#fff",
    fontSize: "18px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
  },
  hasBulkActionsBar: {
    marginTop: "55px", // the height of the bulk actions bar
    height: "calc(100% - 55px)",
  },
  attendeeDetails: {
    display: "flex",
    alignItems: "center",
  },
  attendeeName: {
    fontWeight: "bold",
    fontSize: "16px",
    mr: 1,
  },
  attendeeCompany: {
    fontWeight: "lighter",
    wordBreak: "break-word",
  },
  registrationStatus: {
    fontSize: "10px",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRadius: "5px",
    color: "#fff",
    marginRight: theme.spacing(1),
    height: "auto",
    "& .MuiChip-label": {
      p: 0,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
  attendeeAvatar: {
    // backgroundColor: theme.palette.primary.main,
    marginRight: "14px",
  },
  checkedAvatar: {
    backgroundColor: theme.palette.primary.main,
    marginRight: "16px",
  },
  actions: {
    paddingLeft: "10px",
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    '& .MuiIconButton-root.actionIcon': {
      marginLeft: "10px",
      p: 0,
      zIndex: 10,
      '& svg': {
        fontSize: "16px",
      }
    }
  },
  viewIcon: {
    visibility: "hidden",
    marginLeft: "10px",
    zIndex: 10,
    fontSize: "16px",
    display: "flex",
  },
  activeRow: {
    "& attendeeAvatar": {
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
    },
    "& .attendeeDetails": {
      color: "#fff",
    },
  },
  checkboxIcon: {
    position: "relative",
    minWidth: "inherit",
    mr: 1,
  },
  avatarIcon: {
    minWidth: "initial",
    marginRight: "16px",
  },
  whiteCheckboxInput: { color: "#fff !important" },
  //   listIcon:{
  //     display: "block",
  //     position: "relative",
  //     minWidth: "40px",
  //   },
  listItem:{
    "&.fdListItem":{
      "&.hightLightItemOrange":{
        backgroundColor:"#F8D89E",
        borderBottom:"1px solid #f1c77b",
        "& .MuiListItemText-root .MuiTypography-root": {
          color: "#d88c02",
        },
        "&:hover": {
          backgroundColor:"#f8c871",
          "& .MuiListItemText-root .MuiTypography-root": {
            color: "#d88c02",
          },
        }
      },  
      "&.hightLightItemRed":{
        backgroundColor:"#F6E8E6",
        borderBottom:"1px solid #f7d7d2",
        "& .MuiListItemText-root .MuiTypography-root": {
          color: "#f36d5a",
        },
        "&:hover": {
          backgroundColor:"#f6d0ca",
          "& .MuiListItemText-root .MuiTypography-root": {
            color: "#f36d5a",
          },
        }
      },
    }
  }
} as const;